module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "calibre8"
  }, [_vm._v("Dramatis personae")]), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }), _vm._v(" "), _c('table', {
    staticClass: "true",
    attrs: {
      "cellpadding": "5",
      "cellspacing": "0",
      "summary": "Personen"
    }
  }, [_c('tbody', [_c('tr', {
    staticClass: "calibre6"
  }, [_c('td', {
    staticClass: "calibre7"
  }, [_c('span', [_vm._v("Vater Helmbrecht")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', [_vm._v("Mutter Helmbrecht")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', [_vm._v("Griselda, ihre Tochter")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', [_vm._v("Markgraf Ulrich")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', [_vm._v("Graf Eberhard")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', [_vm._v("Gräfin Eberhard")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', [_vm._v("Graf Heinz")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', [_vm._v("Die Baronin")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', [_vm._v("Der Fürst")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', [_vm._v("Erster Baron")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', [_vm._v("Zweiter Baron")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', [_vm._v("Dritter Baron")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', [_vm._v("Der Schloßpropst")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', [_vm._v("Der Haushofmeister")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', [_vm._v("Der Kastellan")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', [_vm._v("Der Arzt")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', [_vm._v("Erste Dame")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', [_vm._v("Zweite Dame")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', [_vm._v("Die Pflegefrau")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', [_vm._v("Die andere Pflegefrau")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', [_vm._v("Die Kammerfrau")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', [_vm._v("Die Amme")]), _c('br', {
    staticClass: "calibre2"
  }), _vm._v(" "), _c('span', [_vm._v("Wäscherinnen")])])])])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "calibre5"
  }, [_c('span', [_vm._v("Jäger, Diener, zwei Mönche,\nGeistlichkeit, Taufzug")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a637da12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0002.vue
// module id = 60
// module chunks = 0